import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './InfoPages.css';

const supportEmail = 'oneclickservs@gmail.com';
const supportPhone = '+91 8240316090';

const InfoPages = () => {
  const { pathname } = useLocation();
  const page = pathname.replace(/^\/|\/$/g, '');

  const renderContent = () => {
    switch (page) {
      case 'about':
        return (
          <>
            <span className="info-page__eyebrow">About OneClick</span>
            <h1>Good help, without the endless search.</h1>
            <p className="info-page__lead">
              OneClick helps people discover local service professionals for the jobs that keep
              homes and everyday life running.
            </p>
            <div className="info-page__panel">
              <h2>Our goal</h2>
              <p>
                Make it easier to explore services, compare options and connect with a professional
                who can help. Start by browsing the services available in your area.
              </p>
              <Link className="info-page__button" to="/services">Explore services</Link>
            </div>
          </>
        );
      case 'careers':
        return (
          <>
            <span className="info-page__eyebrow">Careers</span>
            <h1>Build a more helpful way to find services.</h1>
            <p className="info-page__lead">
              We welcome interest from people who care about making local services easier to find
              and book.
            </p>
            <div className="info-page__panel">
              <h2>Interested in working with OneClick?</h2>
              <p>Tell us a little about yourself and the kind of work you are interested in.</p>
              <a
                className="info-page__button"
                href={`mailto:${supportEmail}?subject=${encodeURIComponent('Careers at OneClick')}`}
              >
                Email our team
              </a>
            </div>
          </>
        );
      case 'contact':
        return (
          <>
            <span className="info-page__eyebrow">Contact</span>
            <h1>We’re here to help.</h1>
            <p className="info-page__lead">
              Reach out with a question about OneClick, finding a service, or using your account.
            </p>
            <div className="info-page__contact-grid">
              <a className="info-page__panel info-page__contact-card" href={`mailto:${supportEmail}`}>
                <span className="info-page__contact-label">Email</span>
                <strong>{supportEmail}</strong>
                <span>Send us a message</span>
              </a>
              <a className="info-page__panel info-page__contact-card" href="tel:+918240316090">
                <span className="info-page__contact-label">Phone</span>
                <strong>{supportPhone}</strong>
                <span>Call our team</span>
              </a>
            </div>
          </>
        );
      case 'help-center':
        return (
          <>
            <span className="info-page__eyebrow">Help Center</span>
            <h1>Quick answers to help you get started.</h1>
            <div className="info-page__faq-list">
              <section className="info-page__panel">
                <h2>How do I find a service?</h2>
                <p>Browse service categories or use the search field to find the service you need.</p>
              </section>
              <section className="info-page__panel">
                <h2>How do I contact a professional?</h2>
                <p>Open a service listing and follow the available booking or contact options.</p>
              </section>
              <section className="info-page__panel">
                <h2>Where can I get more help?</h2>
                <p>
                  Email <a href={`mailto:${supportEmail}`}>{supportEmail}</a> or call{' '}
                  <a href="tel:+918240316090">{supportPhone}</a>.
                </p>
              </section>
            </div>
          </>
        );
      case 'terms-and-conditions':
        return (
          <>
            <span className="info-page__eyebrow">Terms &amp; Conditions</span>
            <h1>Terms of Use</h1>
            <div className="info-page__draft-notice" role="note">
              Draft starter content — these terms have not been legally reviewed. Please have them
              reviewed and approved before relying on or publishing them as final terms.
            </div>
            <p className="info-page__lead">
              These draft terms describe general expectations for using the OneClick website.
            </p>
            <div className="info-page__terms">
              <section>
                <h2>Using the platform</h2>
                <p>
                  Use OneClick lawfully and provide accurate information when creating an account,
                  requesting a service or communicating with another user.
                </p>
              </section>
              <section>
                <h2>Service providers and bookings</h2>
                <p>
                  Service details, availability, pricing and arrangements may be provided by
                  independent professionals. Confirm the scope, timing and cost directly before
                  work begins.
                </p>
              </section>
              <section>
                <h2>Accounts and conduct</h2>
                <p>
                  Keep your sign-in details secure. Do not misuse the platform, interfere with its
                  operation, or post unlawful, misleading or abusive content.
                </p>
              </section>
              <section>
                <h2>Changes and contact</h2>
                <p>
                  These draft terms may be updated as the service develops. For questions, contact{' '}
                  <a href={`mailto:${supportEmail}`}>{supportEmail}</a>.
                </p>
              </section>
            </div>
          </>
        );
      default:
        return (
          <>
            <span className="info-page__eyebrow">OneClick</span>
            <h1>Page not found</h1>
            <p className="info-page__lead">The page you requested could not be found.</p>
            <Link className="info-page__button" to="/">Go to home</Link>
          </>
        );
    }
  };

  return (
    <section className="info-page">
      <div className="info-page__content">{renderContent()}</div>
    </section>
  );
};

export default InfoPages;
